import {MacroItemTypeValue} from '../../macros/macros.types';
import {ConditionType} from '../conditions.types';

export function getConditionType(condType: MacroItemTypeValue): ConditionType {
  if (!condType) {
    return ConditionType.Text;
  }

  switch (condType) {
    case MacroItemTypeValue.Date:
    case MacroItemTypeValue.DateList:
      return ConditionType.Date;
    case MacroItemTypeValue.Numeric:
      return ConditionType.Number;
    case MacroItemTypeValue.Condition:
      return ConditionType.Boolean;
    default:
      return ConditionType.Text;
  }
}
